import type { TFunction } from 'i18next';
import type { IDeliverySource } from '@interfaces/ILogistics';
import type { DeliveryLineBody } from '@apis/logistics';
import type { OrderPrefill } from './orderPrefill';

/** One material of the new order: its seed values, and the task's `source`
 *  that line is stamped with — the claim's need as the task's share. */
export interface IOrderHandoffLine {
  prefill: OrderPrefill;
  source: IDeliverySource;
}

/** One add to an order already on its way, ready to post
 *  (`addDeliveryLine(siteId, ref, body)`). `claimId` names the claim it is
 *  for, so a failed write can be reported against it. */
export interface IJoinWrite {
  claimId: string;
  ref: string;
  body: DeliveryLineBody;
}

/**
 * What the Scheduler's Stock tab checkout hands to the delivery dialog —
 * right there above the task drawer, never a page away (contract v14): one
 * line per material the new order carries, the adds to orders already on
 * their way that Create also performs, and enough of the task to explain
 * where the order came from.
 */
export interface IOrderHandoff {
  lines: IOrderHandoffLine[];
  joins: IJoinWrite[];
  taskName: string;
  floorName: string | null;
}

/**
 * The line above Material — "For task X · Stock tab · Floor". A task with no
 * assigned floor claims against the whole building, so there is no floor to
 * name: a separate key, not an interpolated empty string, or the note ends in
 * a dangling " · ".
 */
export function originNoteFor(handoff: IOrderHandoff, t: TFunction): string {
  return handoff.floorName === null
    ? t('logistics.orderDialog.originNoFloor', { task: handoff.taskName })
    : t('logistics.orderDialog.origin', { task: handoff.taskName, floor: handoff.floorName });
}
